/*
  Oto Athletics: mejoras de navegación
  1. Ficha de producto: al cambiar de color, si la talla elegida no existe o está agotada
     en ese color, salta a la primera talla disponible (así la foto y el botón se actualizan).
  2. Colecciones: al filtrar por talla (u otra opción de variante), aplica "En stock"
     automáticamente para que solo aparezcan productos con esa talla disponible.
     Requiere el filtro de Disponibilidad activo en Search & Discovery.
*/
(function () {
  // Guardamos el último valor de opción que tocó el cliente (fase de captura,
  // corre antes que el listener de <variant-selects>).
  let lastChangedOptionValueId = null;
  document.addEventListener(
    'change',
    (event) => {
      const el = event.target;
      if (!el || !el.closest || !el.closest('variant-selects')) return;
      const input = el.tagName === 'SELECT' ? el.selectedOptions[0] : el;
      lastChangedOptionValueId = input && input.dataset ? input.dataset.optionValueId : null;
    },
    true
  );

  function readVariantMap(productInfo) {
    const node = productInfo.querySelector('variant-selects [data-oto-variant-map]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function resolveOptionValues(productInfo, optionValues) {
    const map = readVariantMap(productInfo);
    if (!map || !lastChangedOptionValueId || !optionValues || !optionValues.length) return optionValues;

    // id del valor -> { posición de la opción, nombre }
    const info = {};
    map.options.forEach((values, pos) => {
      Object.keys(values).forEach((name) => {
        info[String(values[name])] = { pos, name };
      });
    });

    const selected = [];
    for (const id of optionValues) {
      const item = info[String(id)];
      if (!item) return optionValues;
      selected[item.pos] = item.name;
    }

    const changed = info[String(lastChangedOptionValueId)];
    if (!changed) return optionValues;

    const sameAs = (variant, upTo) => variant.o.every((name, i) => i > upTo || name === selected[i]);
    const exact = map.variants.find((v) => sameAs(v, Infinity));
    if (exact && exact.a) return optionValues; // la combinación existe y tiene stock

    // Mantener fijas la opción tocada y las anteriores (ej. Color); ajustar las siguientes (ej. Talla).
    const sameBase = map.variants.filter((v) => sameAs(v, changed.pos));
    if (!sameBase.length) return optionValues;

    const available = sameBase.filter((v) => v.a);
    let best = null;
    if (available.length) {
      // Preferir la que conserve más de lo que el cliente tenía elegido; si empatan, el orden del producto.
      const keep = (v) => v.o.reduce((s, name, i) => s + (i > changed.pos && name === selected[i] ? 1 : 0), 0);
      best = available.reduce((a, b) => (keep(b) > keep(a) ? b : a));
    } else if (!exact) {
      // Nada disponible en este color: mostrar al menos una variante que exista (foto + "Agotado").
      best = sameBase[0];
    }
    if (!best) return optionValues;

    return best.o.map((name, i) => map.options[i][name]);
  }

  customElements.whenDefined('product-info').then(() => {
    const ProductInfo = customElements.get('product-info');
    const original = ProductInfo.prototype.buildRequestUrlWithParams;
    if (!original || original.__otoPatched) return;

    const patched = function (url, optionValues, shouldFetchFullPage) {
      let values = optionValues;
      try {
        if (url === this.dataset.url) values = resolveOptionValues(this, optionValues);
      } catch (e) {
        values = optionValues;
      }
      lastChangedOptionValueId = null;
      return original.call(this, url, values, shouldFetchFullPage);
    };
    patched.__otoPatched = true;
    ProductInfo.prototype.buildRequestUrlWithParams = patched;
  });

  customElements.whenDefined('facet-filters-form').then(() => {
    const FacetForm = customElements.get('facet-filters-form');
    const original = FacetForm.prototype.createSearchParams;
    if (!original || original.__otoPatched) return;

    const patched = function (form) {
      const params = new URLSearchParams(original.call(this, form));
      const hasVariantOption = Array.from(params.keys()).some((key) => key.indexOf('filter.v.option.') === 0);
      if (hasVariantOption && !params.has('filter.v.availability')) {
        params.append('filter.v.availability', '1');
      }
      return params.toString();
    };
    patched.__otoPatched = true;
    FacetForm.prototype.createSearchParams = patched;
  });
})();

/*
  Oto Athletics: ficha de producto
  3. Enlaces "Guía de tallas", "Cambios", etc. abren su desplegable y bajan hasta él.
  4. Galería por color: muestra solo las fotos del color elegido (según el texto alternativo
     de cada foto, que incluye el nombre del color). Las fotos sin color en el texto se muestran siempre.
*/
(function () {
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('[data-oto-open]');
    if (!link) return;
    const target = document.getElementById(link.dataset.otoOpen);
    if (!target) return;
    event.preventDefault();
    if (target.tagName === 'DETAILS') target.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function colorFieldset(scope) {
    return Array.from(scope.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input')).find((el) => {
      const label = el.querySelector('legend, label.form__label');
      return label && /color/i.test(label.textContent);
    });
  }

  /* Nombres de color en español que usan los textos alternativos, y su equivalente en la tienda. */
  const ES = [
    ['azul marino', 'navy'], ['verde musgo', 'moss'], ['rojo cereza', 'red cherry'],
    ['negro', 'black'], ['blanco', 'white'], ['marfil', 'ivory'], ['gris', 'gray'],
    ['verde', 'green'], ['azul', 'blue'], ['naranja', 'orange'], ['amarillo', 'yellow'],
    ['violeta', 'violet'], ['rayas', 'stripes'], ['rosado', 'pink'], ['rosa', 'pink'],
    ['marron', 'brown'], ['rojo', 'red'], ['beige', 'beige'], ['con', 'with'], ['y', 'and'],
  ];

  function norm(text) {
    let t = ' ' + String(text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/grey/g, 'gray').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ') + ' ';
    return t.replace(/\s+/g, ' ');
  }

  function normAlt(alt) {
    let t = norm(alt);
    ES.forEach(([es, en]) => { t = t.split(' ' + es + ' ').join(' ' + en + ' '); });
    return t;
  }

  /* Devuelve el color al que pertenece la foto (el nombre más largo que aparece en su texto), o null. */
  function colorOf(alt, values) {
    const a = normAlt(alt);
    let best = null;
    let bestLen = 0;
    values.forEach((v) => {
      const n = norm(v);
      if (n.trim() && a.includes(n) && n.length > bestLen) { best = v; bestLen = n.length; }
    });
    return best;
  }
  window.otoColorOf = colorOf;

  function filterGallery(productInfo) {
    try {
      const fieldset = colorFieldset(productInfo);
      if (!fieldset) return;
      const values = Array.from(fieldset.querySelectorAll('input, option')).map((i) => i.value).filter(Boolean);
      const checked = fieldset.querySelector('input:checked') || fieldset.querySelector('option:checked');
      if (!checked || values.length < 2) return;
      const selected = checked.value;
      const gallery = productInfo.querySelector('media-gallery');
      if (!gallery) return;
      gallery.querySelectorAll('li[data-media-id], li[data-target]').forEach((li) => {
        const img = li.querySelector('img');
        const color = colorOf(img ? img.alt : '', values);
        li.classList.toggle('oto-hidden-media', color !== null && color !== selected);
      });
    } catch (e) {
      /* si algo falla, la galería queda como está */
    }
  }

  const style = document.createElement('style');
  style.textContent = '.oto-hidden-media{display:none !important}';
  document.head.appendChild(style);

  function filterAll() {
    document.querySelectorAll('product-info').forEach(filterGallery);
  }

  document.addEventListener('DOMContentLoaded', filterAll);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(filterAll, 50));
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(filterAll, 50));
      }
    });
  }
})();
